import {
  MEDIA_SUCCESS,
  MEDIA_REMOVE_UPLOAD_ITEM,
  MEDIA_UPDATE_UPLOAD_PROGRESS,
  MEDIA_UPLOAD_SUCCESS,
  MEDIA_UPLOAD_ERROR,
  MEDIA_UPLOAD_FILE_START,
  MEDIA_LIBRARY_RESET_STATE,
  MEDIA_LIBRARY_SET_PAGE,
  MEDIA_LIBRARY_SET_SEARCH_PHRASE,
  MEDIA_LIBRARY_INCREASE_PAGE, MEDIA_REQUEST,
} from '../actions/media';

export const initialState = {
  uploadQueue: {},
  library: {
    page: 1,
    searchPhrase: '',
  },
};

const media = (state = initialState, action) => {
  switch (action.type) {
    case MEDIA_UPLOAD_FILE_START: {
      const queue = { ...state.uploadQueue };
      const { file, uniqId } = action.value;

      queue[uniqId] = {
        startAt: (new Date()).getTime(),
        isUploading: true,
        uniqueId: uniqId,
        file,
        progress: 0,
      };

      return {
        ...state,
        uploadQueue: queue,
      };
    }
    case MEDIA_UPDATE_UPLOAD_PROGRESS: {
      const queue = { ...state.uploadQueue };
      const { file, progress, uniqId } = action.value;

      queue[uniqId] = {
        ...queue[uniqId],
        file,
        progress,
      };

      return {
        ...state,
        uploadQueue: queue,
      };
    }
    case MEDIA_UPLOAD_SUCCESS: {
      const queue = { ...state.uploadQueue };
      const { uploadId } = action.metadata;
      const mediaItem = queue[uploadId];

      if (mediaItem) {
        delete queue[uploadId];
      }

      return {
        ...state,
        uploadQueue: queue,
      };
    }
    case MEDIA_UPLOAD_ERROR: {
      const queue = { ...state.uploadQueue };
      const { uniqId, message } = action.value;

      if (queue[uniqId]) {
        queue[uniqId].error = message;
      }

      return {
        ...state,
        uploadQueue: queue,
      };
    }
    case MEDIA_REMOVE_UPLOAD_ITEM: {
      const queue = { ...state.uploadQueue };
      const { uniqId } = action.value;

      if (queue[uniqId]) {
        delete queue[uniqId];
      }

      return {
        ...state,
        uploadQueue: queue,
      };
    }
    case MEDIA_SUCCESS: {
      const queue = { ...state.uploadQueue };
      Object.keys(queue).forEach((key) => {
        const item = queue[key];

        if (!item.isUploading) {
          delete queue[key];
        }
      });

      return {
        ...state,
        uploadQueue: queue,
      };
    }
    case MEDIA_REQUEST: {
      return {
        ...state,
        library: {
          page: 1,
        },
      };
    }
    case MEDIA_LIBRARY_RESET_STATE: {
      return {
        ...state,
        library: initialState.library,
      };
    }
    case MEDIA_LIBRARY_INCREASE_PAGE: {
      return {
        ...state,
        library: {
          ...state.library,
          page: state.library.page + 1,
        },
      };
    }
    case MEDIA_LIBRARY_SET_PAGE: {
      const { page } = action.value;

      return {
        ...state,
        library: {
          ...state.library,
          page: +page,
        },
      };
    }
    case MEDIA_LIBRARY_SET_SEARCH_PHRASE: {
      const { phrase } = action.value;

      return {
        ...state,
        library: {
          page: 1,
          searchPhrase: phrase || '',
        },
      };
    }
    default:
      return state;
  }
};

export default media;



// WEBPACK FOOTER //
// ./src/reducers/media.js